import React from 'react';
import {
    ReactComponent as PatternIco
} from "../../../../../../../../images/backgrounds/multistore/ordering-step-pattern.svg";

interface Props {
    step: number;
    title: string;
    content?: JSX.Element;
}

const MultistoreOrderingStep = ({step, title, content}: Props) => {
    return (
        <div className="multistore-ordering-step">
            <div className="rounded-icon medium fw-bolder">
                <div className="ellipse ellipse-transparent"/>
                {step}
            </div>
            <div className="content-container">
                <p className="mb-0 text-muted fw-normal">{title}</p>
                {content && <div className="content">{content}</div>}
            </div>
            <PatternIco className="pattern-ico"/>
        </div>
    )
}

export default MultistoreOrderingStep;